import { useCallback, useState } from 'react';

const LS_KEY = 'combos_theme';

const readTheme = () => {
    try {
        return localStorage.getItem(LS_KEY) === 'light' ? 'light' : 'dark';
    } catch (e) {
        return 'dark';
    }
};

const applyTheme = (theme) => {
    document.documentElement.setAttribute('data-theme', theme);
};

// Stamp the persisted theme onto <html> as early as possible (called once from
// App, outside any component) so the page never flashes the wrong theme.
export const initializeTheme = () => {
    applyTheme(readTheme());
};

export const useThemePreference = () => {
    const [theme, setThemeState] = useState(readTheme);

    const setTheme = useCallback((value) => {
        setThemeState((current) => {
            const nextValue = typeof value === 'function' ? value(current) : value;
            try {
                localStorage.setItem(LS_KEY, nextValue);
            } catch (e) { /* ignore unavailable local storage */ }
            applyTheme(nextValue);
            return nextValue;
        });
    }, []);

    return [theme, setTheme];
};
